<template>
    <div class="store-cta-gallery-item">
        <AutoplayVideo :video />

        <a
            href="/visit-us"
            class="store-cta-button"
            @click="trackCta"
            >SEE IN STORE</a
        >
    </div>
</template>

<script setup lang="ts">
import type { CatalogueVideo } from '@/graphql/api'

import AutoplayVideo from '@/components/AutoplayVideo.vue'

const video: CatalogueVideo = {
    __typename: 'CatalogueVideo',
    type: 'video/mp4',
    uri: 'https://taylorandhart.com/cms-media/2026/01/taylor-and-hart-store-video.mp4',
}

import { getWindow } from '@/helpers/globals.ts'
import { useSegment } from '@/third-party/segment.ts'
const { track } = useSegment()

const trackCta = () => {
    const url = getWindow()?.location.href

    if (!url) {
        return
    }

    track('custom_see_in_store_cta_click', {
        param1: 'see_in_store_cta',
        param2: 'click',
        param3: 'pdp_gallery_tile',
        param4: url,
        url,
        event_name: 'see_in_store_cta_click',
    })
}
</script>

<style scoped lang="scss">
.store-cta-gallery-item {
    width: 100%;
    max-width: 900px;
    max-height: 100vh;
    aspect-ratio: 1/1;
    position: relative;
    cursor: initial;
    container-name: gallery-item;
    container-type: inline-size;

    .store-cta-button {
        position: absolute;
        bottom: 40px;
        background: $blue;
        color: $white;
        cursor: pointer;
        display: block;
        text-transform: uppercase;
        font-family: $effra-font-stack;
        font-size: 0.875rem;
        letter-spacing: 0.05em;
        line-height: 20px;
        padding: 11px 10px 9px;
        border-radius: 20px;
        width: 150px;
        left: 0;
        right: 0;
        margin: 0 auto;
        text-align: center;

        @include min-width(768) {
            bottom: 80px;
        }
    }

    :deep(.th-video) {
        object-fit: contain;
        height: 100%;
        aspect-ratio: 1/1;
    }
}
</style>
